import React from 'react'
import {SidebarInset, SidebarProvider} from 'ui-v2'
import {WorkspaceProvider} from '~/hooks/useWorkspace'
import {MenuView} from '../versionMenu/MenuView'

export interface LayoutProps {
	children: React.ReactNode
}

const LayoutContent: React.FC<LayoutProps> = ({children}) => {
	return (
		<SidebarProvider>
			<MenuView />
			<SidebarInset>{children}</SidebarInset>
		</SidebarProvider>
	)
}

const Layout: React.FC<LayoutProps> = ({children}) => {
	return (
		<WorkspaceProvider>
			<LayoutContent>{children}</LayoutContent>
		</WorkspaceProvider>
	)
}
export default Layout
